import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Config } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

Config.loadInstance('assets/config.json')
.then(()=>{
  platformBrowserDynamic().bootstrapModule(AppModule);
});





// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/main.ts